import React from 'react';
import { t, L as Loader } from './index-582e4b38.js';

var s = {"content":"_h-content-668b","statusWrapper":"_h-statusWrapper-5c2e","product":"_h-product-93b4","advantage":"_h-advantage-85d9","emptyLabel":"_h-emptyLabel-2b30","logoPriceClub":"_h-logoPriceClub-c6e7","percent":"_h-percent-cc2d","noPadding":"_h-noPadding-f226","membership":"_h-membership-484c","deleteIcon":"_h-deleteIcon-97b9","picProduct":"_h-picProduct-706f","warranty":"_h-warranty-2a43","labelTotal":"_h-labelTotal-d4ff","bt":"_h-bt-7ea6"};

// Librairies
// Render
var CartLoader = function () { return (React.createElement("div", { className: "".concat(t['dark-gray'], " ").concat(s.content, " ").concat(t.flex, " ").concat(t['justify-center']) },
    React.createElement(Loader, null))); };

export { CartLoader as C, s };
